// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","content":"home_content__qfqpv"};